import {AuthoringSubjectModelV1} from 'resources/GeneratedModels/AuthoringSubject/AuthoringSubjectModel.v1';
import {authoringSubjectExtensions} from './authoringSubject.extensions';
import {authoringSubjectValidators} from './authoringSubject.validators';
import {subjectExtensions} from 'resources/augmented/Subject/subject.extensions';

AuthoringSubjectModelV1.extend(subjectExtensions, authoringSubjectExtensions);
AuthoringSubjectModelV1.addValidators(authoringSubjectValidators);

export {AuthoringSubjectModelV1};
